import CompaniesService from '@/services/web/companies.service'
import UsersService from '@/services/web/users.service'
import LogsService from '@/services/web/logs.service'
import StatementService from '@/services/web/statement.service'
import ConsumptionService from '@/services/web/consumption.service'
import ProjectService from '@/services/web/project.service'
import ExportService from '@/services/web/export.service'
import NodeService from '@/services/web/node.service'
import MeterService from '@/services/web/meter.service'
import TransportService from '@/services/web/transport.service'
import TaskService from '@/services/web/task.service'
import ApkService from '@/services/web/apk.service'

let countMethods = 13
let currentMethod = 0

let sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const actions = {
  loadAllApiAsync() {
    return this.dispatch('api/loadPeriodTypesAsync')
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadRecordTypesAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadCompanyTypesAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadRolesAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadLogActionsAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadLogObjectsAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadEnergyTypesAsync')
    })
    .then(()=> { 
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadNodeTypesAsync')
    })
    .then(()=> { 
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadEnergyMeterTypesAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadTransportTecnologiesAsync')
    })
    /*.then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadProjectGroupsAsync')
    })*/
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadProjectTypesAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadExportProviderTypesAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadTaskTypesAsync')
    })
    .then(()=> {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return this.dispatch('api/loadPaperActTypesAsync')
    })
    .then(() => {
      currentMethod++
      this.dispatch('api/setPercentageOfLoads', {countMethods, currentMethod}); 
      return sleep(1000);
    })    
    .catch(exc => {
      console.log('VUEX loadAllApiAsync(): ', exc)
    })
  },

  setPercentageOfLoads(context, params) {    
    let percentage = Math.round(params.currentMethod / params.countMethods * 100)
    //console.log(countMethods, currentMethod, percentage)
    context.commit('SET_PERCENTAGE_OF_LOADS', percentage)
  },

  loadCompanyTypesAsync(context) {
    return CompaniesService.getTypes()
    .then(result => {
      console.log('loadCompanyTypesAsync - OK')
      context.commit('SET_COMPANY_TYPES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadCompanyTypesAsync', exc)
    })*/
  },

  loadRolesAsync(context) {
    return UsersService.getRoles()
    .then(result => {
      console.log('loadRolesAsync - OK')
      context.commit('SET_ROLES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadRolesAsync', exc)
    })*/
  },

  loadEnergyTypesAsync(context) {
    return UsersService.getEnergyTypes(null) 
    .then(result  => { 
      console.log('loadEnergyTypesAsync - OK')
      context.commit('SET_ENERGY_TYPES', result.data)
    })
    /*.catch( exc => { 
      console.log('VUEX: loadEnergyTypesAsync', exc)
    })*/
  },

  loadNodeTypesAsync(context) {
    return NodeService.getTypes()
    .then(result  => {   
      console.log('loadNodesTypesAsync - OK')   
      context.commit('SET_NODE_TYPES', result.data)
    })
    /*.catch( exc => { 
      console.log('Error loadEnergyMeterTypes() ' + exc) 
    })*/
  },    

  loadEnergyMeterTypesAsync(context) {
    return MeterService.getEnergyMeterTypes(null)
    .then(result  => {   
      console.log('loadEnergyMeterTypesAsync - OK')   
      context.commit('SET_ENERGY_METER_TYPES', result.data)
    })
    /*.catch( exc => { 
      console.log('Error loadEnergyMeterTypes() ' + exc) 
    })*/
  },    

  loadTransportTecnologiesAsync(context) {
    return TransportService.getTechnologies(null)
    .then (result => {
      console.log('loadTransportTecnologiesAsync - OK')
      context.commit('SET_TRANSPORT_TECHNOLOGIES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadTransportTecnologiesAsync() ' + exc)
    })*/
  },

  loadLogActionsAsync(context) {
    return LogsService.getActions()
    .then(result  => { 
      console.log('loadLogActionsAsync - OK')
      context.commit('SET_LOG_ACTIONS', result.data)
    })
    /*.catch( exc => { 
      console.log('VUEX: loadLogActions() ' + exc) 
    })*/
  }, 
  
  loadLogObjectsAsync(context) {
    return LogsService.getObjects()
    .then(result  => { 
      console.log('loadLogObjectsAsync - OK')
      context.commit('SET_LOG_OBJECTS', result.data)
    })
    /*.catch( exc => { 
      console.log('VUEX: loadLogObjects() ' + exc) 
    })*/
  }, 

  loadRecordTypesAsync(context) {
    return StatementService.getRecordTypes()
    .then(result => {
      console.log('loadRecordTypesAsync - OK')
      context.commit('SET_RECORD_TYPES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadRecordTypesAsync', exc)
    })*/
  },

  loadPeriodTypesAsync(context) {
    return ConsumptionService.getPeriodTypes()
    .then(result => {
      console.log('loadPeriodTypesAsync - OK')
      context.commit('SET_PERIOD_TYPES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadPeriodTypesAsync', exc)
    })*/
  },

  /*loadProjectGroupsAsync(context) {
    return ProjectService.getGroups(null)
    .then(result => {
      console.log('loadProjectGroupsAsync - OK')
      context.commit('SET_PROJECT_GROUPS', result.data)
    })
    /*.catch( exc => {
        console.log('VUEX: Error loadProjectGroups() ' + exc)
    })*/
  //},  

  loadProjectTypesAsync(context) {
    return ProjectService.getTypes(null)
    .then (result => {
      console.log('loadProjectTypesAsync - OK')
      context.commit('SET_PROJECT_TYPES', result.data)
    })
    /*.catch( exc => {
        console.log('VUEX: loadProjectTypes() ' + exc)
    })*/
  },

  loadExportProviderTypesAsync(context) {
    return ExportService.getExportProviderTypes()
    .then(result => {
      console.log('loadExportProviderTypesAsync - OK')
      context.commit('SET_EXPORT_PROVIDERS_TYPES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadExportProviderTypes() ' + exc)
    })*/
  },

  loadTaskTypesAsync(context) {
    return TaskService.getTypes()
    .then(result => {
      console.log('loadTaskTypesAsync - OK')
      context.commit('SET_TASK_TYPES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadTaskTypesAsync() ' + exc)
    })*/
  },

  loadPaperActTypesAsync(context) {
    return ApkService.getPaperActTypes(null)
    .then(result => {
      console.log('loadPaperActTypesAsync - OK')
      context.commit('SET_PAPER_ACT_TYPES', result.data)
    })
    /*.catch(exc => {
      console.log('VUEX: loadTaskTypesAsync() ' + exc)
    })*/
  },
}

export default actions